/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import { ROUTE_PATHS } from "../../routeConstants";
import Dashboard from "../Dashboard/index";
import Login from "../Login/Login";

const Routes = () => {
  const [isRestricted, setIsRestricted] = useState(false);
  const [allowedFunctions, setAllowedFunctions] = useState([]);
  const [sensitiveAllowedActions, setSensitiveAllowedActions] = useState([]);

  return (
    <Router>
      <Switch>
        {/* Authentication Routes */}
        <Route
          exact
          path={ROUTE_PATHS.ROOT}
          render={() => (
            <Login
              setIsRestricted={setIsRestricted}
              setAllowedFunctions={setAllowedFunctions}
            />
          )}
        />
        <Route
          exact
          path={ROUTE_PATHS.LOGIN}
          render={() => (
            <Login
              setIsRestricted={setIsRestricted}
              setAllowedFunctions={setAllowedFunctions}
            />
          )}
        />

        {/* Dashboard Routes - Handle all /dashboard/* routes */}
        <Route
          path={ROUTE_PATHS.DASHBOARD}
          render={() => (
            <Dashboard
              isRestricted={isRestricted}
              setIsRestricted={setIsRestricted}
              setAllowedFunctions={setAllowedFunctions}
              allowedFunctions={allowedFunctions}
              sensitiveAllowedActions={sensitiveAllowedActions}
              setSensitiveAllowedActions={setSensitiveAllowedActions}
            />
          )}
        />

        {/* Fallback redirect to login for unknown routes */}
        <Redirect to={ROUTE_PATHS.LOGIN} />
      </Switch>
    </Router>
  );
};

export default Routes;
